require("./css/font-awesome.min.css");
require("./css/bootstrap.min.css");
require("./css/bootstrap-rtl.scss");
require("./css/owl.carousel.css");
require("./css/owl.theme.default.min.css");
require("./css/styles.css");
require("./bower_components/angular-loading-bar/build/loading-bar.min.css");
require("./bower_components/angular-ui-notification/dist/angular-ui-notification.min.css");
require("./css/ui-notification.css");
require("./css/animations.css");
require("./css/custome.css");
require("./css/english.scss");
require("./css/videoResposive.scss");
require("./css/codeModalResponsive.scss");
window.jQuery = window.$ = require("jquery");
require("./js/scripts/bootstrap.js");

require("./bower_components/angular/angular.js");
require("./bower_components/angular-animate/angular-animate.min.js");
require("./bower_components/angular-bootstrap/ui-bootstrap-tpls.min.js");
require("./bower_components/angular-cookies/angular-cookies.min.js");
require("./bower_components/angular-loading-bar/build/loading-bar.min.js");
require("./bower_components/angular-translate/angular-translate.min.js");
require("./bower_components/angular-ui-notification/dist/angular-ui-notification.min.js");
require("./bower_components/angular-ui-router/release/angular-ui-router.min.js");
require("./bower_components/oclazyload/dist/ocLazyLoad.min.js");
require("./js/app/app.js");
require("./js/app/app.router.js");
require("./js/controllers/MainController.js");
require("./js/controllers/HomeController.js");
require("./js/app/translate.js");
require("./js/app/translateNotification.js");
require("./js/services/CallService.js");
require("./js/services/modalService.js");
require("./js/directive/pressKey.js");
require("./bower_components/moment/min/moment.min.js");
require("./bower_components/moment/min/locales.min.js");
require("./bower_components/angular-timer/dist/assets/js/angular-timer-bower.js");
require("./bower_components/angular-timer/dist/angular-timer.js");
require("./bower_components/humanize-duration/humanize-duration.js");
require("./bower_components/angular-youtube-mb/dist/angular-youtube-embed.min.js");
require("./bower_components/ngInfiniteScroll/build/ng-infinite-scroll.min.js");
require("./bower_components/angular-sanitize/angular-sanitize.js");
require("./bower_components/angular-socialshare/dist/angular-socialshare.js");
require("./bower_components/ng-device-detector/ng-device-detector.js");
require("./bower_components/re-tree/re-tree.js");
require("./js/scripts/countUp.js");
require("./js/scripts/angular-countUp.js");
require("./js/scripts/scripts.js");
$('#privatCourses-wrapper-Carousel').on('slide.bs.carousel', function () {
    if($('.item.one').hasClass('active')) {
        $('.privatCourses-wrapper').css('background-color','#ed6c06')
    }
    if($('.item.two').hasClass('active')) {
        $('.privatCourses-wrapper').css('background-color','#607005')
    }
    if($('.item.three').hasClass('active')) {
        $('.privatCourses-wrapper').css('background-color','#703219')
    }
});

$('.dropdown').on('click', function() {
    $(this).toggleClass('open');
});




// WEBPACK FOOTER //
// ./index.js